<app-page-header [heading]="'Pricing list'" [icon]="'fa-list'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>

  <div class="row">
    <div class="form-group col-lg-6">
      <label>Customer Name</label><span class="text-danger">&nbsp;*</span>
      <ngx-select-dropdown (change)="getCustomer()" [(ngModel)]="customer_data"
                           [config]="utils.dropConfig({displayKey: 'CUSTOMER_NAME',placeholder: 'Select Customer',searchOnKey: 'CUSTOMER_NAME'})"
                           [multiple]="false"
                           [options]="customer_options" class="form-control  size"
                           name="customer"></ngx-select-dropdown>
    </div>
    <div class="form-group col-lg-6">
      <label>Date</label><span class="text-danger">&nbsp;*</span>
      <input (ngModelChange)="pricing_list.date = $event" [max]="getToday()"
             [ngModel]="pricing_list.date | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">
    </div>

  </div>

  <table class="table tbl table-striped table-bordered">
    <thead>
    <tr class="text-center">
      <th width="1%">#</th>
      <th>Item</th>
      <th colspan="2" width="18%">Slab A</th>
      <th colspan="2" width="18%">Slab B</th>
      <th colspan="2" width="18%">Slab C</th>

    </tr>

    <tr *ngIf="(discount_list | json) == '[]'">
      <td class="text-center" colspan="13 ">No data to list</td>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of discount_list;let i=index" style="font-size: 12px">
      <td><label>
        <input (change)="updateChecked(i,data.PURCHASE_DETAILS_ID)" [checked]="data.CHECKED == true"
               class="text-center"
               name="check"
               type="checkbox"
               value="{{data.CHECKED}}"/>
      </label>
      </td>
      <td>{{ data.TRADE_NAME }}</td>
      <td class="text-center"><label>
        <input (change)="updateAChecked(i,data.PURCHASE_DETAILS_ID)"
               [checked]="data.A_CHECK == true"
               name="a_check"
               type="checkbox"
               value="{{data.A_CHECK}}"/>
      </label></td>
      <td>{{ data.SLAB_A_AMOUNT }}</td>
      <td class="text-center"><label>
        <input (change)="updateBChecked(i,data.PURCHASE_DETAILS_ID)"
               [checked]="data.B_CHECK == true"
               name="b_check"
               type="checkbox"
               value="{{data.B_CHECK}}"/>
      </label></td>
      <td>{{ data.SLAB_B_AMOUNT }}</td>
      <td class="text-center"><label>
        <input (change)="updateCChecked(i,data.PURCHASE_DETAILS_ID)"
               [checked]="data.C_CHECK == true"
               name="c_check"
               type="checkbox"
               value="{{data.C_CHECK}}"/>
      </label></td>
      <td>{{ data.SLAB_C_AMOUNT }}</td>
    </tr>
    </tbody>
  </table>
</div>
